import React, { ChangeEvent, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useCombinedStore } from "../store";
import AlfredoIcon from "../assets/alfredo-icon.svg";
import * as Styles from "../styles/SaleOptionEditor.styles";

const SaleOptionEditor: React.FC = () => {
  const { saleOption } = useParams<{ saleOption: string }>();
  const [saleOptionEditorOpen, setSaleOptionEditorOpen] = useState(false);
  const {
    setSubsidiaryDataZustand,
    subsidiaryDataZustand,
    setMessageZustand,
    removeMessageZustand,
    saleOptionEditorOpenZustand,
    setSaleOptionEditorOpenedZustand,
  } = useCombinedStore();
  const [focusedField, setFocusedField] = useState("");
  const [currentSaleOptionInfo, setCurrentSaleOptionInfo] = useState(
    subsidiaryDataZustand.selectedPdv.saleOptions.find(
      (option) => option.itemInfoUuid === saleOption
    )
  );
  useEffect(() => {
    setCurrentSaleOptionInfo(
      subsidiaryDataZustand.selectedPdv.saleOptions.find(
        (option) => option.itemInfoUuid === saleOption
      )
    );
  }, [saleOption, subsidiaryDataZustand.selectedPdv.saleOptions]);
  const toggleMenu = () => {
    let onlyOneSelectedField = true;
    if (saleOptionEditorOpen) {
      const updatedSaleOptions =
        subsidiaryDataZustand.selectedPdv.saleOptions.map((option) => {
          if (option.itemInfoUuid === saleOption) {
            return {
              ...option,
              itemInfoValue: {
                ...option.itemInfoValue,
                saleOptionComponents:
                  option.itemInfoValue.saleOptionComponents.map(
                    (currentComponent) => {
                      if (
                        currentComponent.componentSelected === true &&
                        !onlyOneSelectedField
                      ) {
                        return {
                          ...currentComponent,
                          componentSelected:
                            !currentComponent.componentSelected,
                        };
                      } else if (currentComponent.componentSelected === true) {
                        onlyOneSelectedField = false;
                      }
                      if (currentComponent.componentId === focusedField) {
                        return {
                          ...currentComponent,
                          componentProps: {
                            ...currentComponent.componentProps,
                            componentFocus: true,
                          },
                        };
                      }
                      return currentComponent;
                    }
                  ),
              },
            };
          }
          return option;
        });
      onlyOneSelectedField = true;

      setSubsidiaryDataZustand({
        ...subsidiaryDataZustand,
        selectedPdv: {
          ...subsidiaryDataZustand.selectedPdv,
          saleOptions: updatedSaleOptions,
        },
      });
    } else {
      const updatedSaleOptions =
        subsidiaryDataZustand.selectedPdv.saleOptions.map((option) => {
          if (option.itemInfoUuid === saleOption) {
            return {
              ...option,
              itemInfoValue: {
                ...option.itemInfoValue,
                saleOptionComponents:
                  option.itemInfoValue.saleOptionComponents.map(
                    (currentComponent) => {
                      if (currentComponent.componentProps.componentFocus) {
                        setFocusedField(currentComponent.componentId);
                        return {
                          ...currentComponent,
                          componentProps: {
                            ...currentComponent.componentProps,
                            componentFocus: false,
                          },
                        };
                      }
                      return currentComponent;
                    }
                  ),
              },
            };
          }
          return option;
        });
      setSubsidiaryDataZustand({
        ...subsidiaryDataZustand,
        selectedPdv: {
          ...subsidiaryDataZustand.selectedPdv,
          saleOptions: updatedSaleOptions,
        },
      });
    }
    setSaleOptionEditorOpen(!saleOptionEditorOpen);
    setSaleOptionEditorOpenedZustand(!saleOptionEditorOpen);
    onlyOneSelectedField = true;
  };
  const handleItemInfoStatusChange = (
    componentParam: string,
    columnId?: string
  ) => {
    const updatedSaleOptions =
      subsidiaryDataZustand.selectedPdv.saleOptions.map((option) => {
        if (option.itemInfoUuid === saleOption) {
          return {
            ...option,
            itemInfoValue: {
              ...option.itemInfoValue,
              saleOptionComponents:
                option.itemInfoValue.saleOptionComponents.map((component) => {
                  if (component.componentId === componentParam && !columnId) {
                    return {
                      ...component,
                      componentStatus: !component.componentStatus,
                    };
                  } else if (
                    component.componentId === componentParam &&
                    columnId
                  ) {
                    if (component.componentProps.componentColumns) {
                      const updatedColumns =
                        component.componentProps.componentColumns?.map(
                          (column) => {
                            if (column.columnId === columnId) {
                              return {
                                ...column,
                                columnStatus: !column.columnStatus,
                              };
                            }
                            return column;
                          }
                        );
                      return {
                        ...component,
                        componentProps: {
                          ...component.componentProps,
                          componentColumns: updatedColumns,
                        },
                      };
                    } else if (component.componentProps.componentRows) {
                      const updatedRows =
                        component.componentProps.componentRows?.map((row) => {
                          if (row.rowId === columnId) {
                            return {
                              ...row,
                              rowStatus: !row.rowStatus,
                            };
                          }
                          return row;
                        });
                      return {
                        ...component,
                        componentProps: {
                          ...component.componentProps,
                          componentRows: updatedRows,
                        },
                      };
                    }
                  }
                  return component;
                }),
            },
          };
        }
        return option;
      });
    setSubsidiaryDataZustand({
      ...subsidiaryDataZustand,
      selectedPdv: {
        ...subsidiaryDataZustand.selectedPdv,
        saleOptions: updatedSaleOptions,
      },
    });
  };
  const handleSelectedFieldChange = (componentParam: any) => {
    const updatedSaleOptions =
      subsidiaryDataZustand.selectedPdv.saleOptions.map((option) => {
        if (option.itemInfoUuid === saleOption) {
          return {
            ...option,
            itemInfoValue: {
              ...option.itemInfoValue,
              saleOptionComponents:
                option.itemInfoValue.saleOptionComponents.map(
                  (currentComponent) => {
                    if (
                      currentComponent.componentId ===
                      componentParam.componentId
                    ) {
                      return {
                        ...currentComponent,
                        componentSelected: !currentComponent.componentSelected,
                      };
                    }
                    return currentComponent;
                  }
                ),
            },
          };
        }
        return option;
      });

    setSubsidiaryDataZustand({
      ...subsidiaryDataZustand,
      selectedPdv: {
        ...subsidiaryDataZustand.selectedPdv,
        saleOptions: updatedSaleOptions,
      },
    });
  };
  const handleItemInfoValueChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any,
    fieldName: string,
    componentId?: string,
    columnId?: string
  ) => {
    e.preventDefault();
    if (componentId) {
      const updatedSaleOptions =
        subsidiaryDataZustand.selectedPdv.saleOptions.map((option) => {
          if (option.itemInfoUuid === saleOption) {
            return {
              ...option,
              itemInfoValue: {
                ...option.itemInfoValue,
                saleOptionComponents:
                  option.itemInfoValue.saleOptionComponents.map((component) => {
                    if (component.componentId === componentId) {
                      if (fieldName.includes("componentPosition.")) {
                        return {
                          ...component,
                          componentProps: {
                            ...component.componentProps,
                            componentPosition: {
                              ...component.componentProps.componentPosition,
                              [fieldName.split(".")[1]]: e.target.value,
                            },
                          },
                        };
                      } else if (fieldName.includes("componentColumns.")) {
                        const updatedColumns =
                          component.componentProps.componentColumns?.map(
                            (column) => {
                              if (column.columnId === columnId) {
                                return {
                                  ...column,
                                  [fieldName.split(".")[1]]: e.target.value,
                                };
                              }
                              return column;
                            }
                          );
                        return {
                          ...component,
                          componentProps: {
                            ...component.componentProps,
                            componentColumns: updatedColumns,
                          },
                        };
                      } else if (fieldName.includes("componentRows.")) {
                        const updatedRows =
                          component.componentProps.componentRows?.map((row) => {
                            if (row.rowId === columnId) {
                              return {
                                ...row,
                                [fieldName.split(".")[1]]: e.target.value,
                              };
                            }
                            return row;
                          });
                        return {
                          ...component,
                          componentProps: {
                            ...component.componentProps,
                            componentRows: updatedRows,
                          },
                        };
                      } else if (fieldName.includes("componentFocus")) {
                        return {
                          ...component,
                          componentProps: {
                            ...component.componentProps,
                            componentFocus: !Boolean(
                              component.componentProps.componentFocus
                            ),
                          },
                        };
                      } else if (fieldName.includes("componentShortcut")) {
                        let shortcutKey = e.key;

                        // Verifica se a tecla pressionada foi "Delete" ou "Backspace" enquanto "Shift" estava pressionada
                        if (
                          e.shiftKey &&
                          (e.key === "Delete" || e.key === "Backspace")
                        ) {
                          shortcutKey = ""; // ou null, dependendo do que você quer usar para representar um atalho vazio
                        }
                        return {
                          ...component,
                          componentProps: {
                            ...component.componentProps,
                            componentShortcut: shortcutKey,
                          },
                        };
                      } else {
                        return {
                          ...component,
                          componentProps: {
                            ...component.componentProps,
                            [fieldName]: e.target.value,
                          },
                        };
                      }
                    }
                    return component;
                  }),
              },
            };
          }
          return option;
        });

      setSubsidiaryDataZustand({
        ...subsidiaryDataZustand,
        selectedPdv: {
          ...subsidiaryDataZustand.selectedPdv,
          saleOptions: updatedSaleOptions,
        },
      });
    } else {
      const updatedSaleOptions =
        subsidiaryDataZustand.selectedPdv.saleOptions.map((option: any) => {
          if (option.itemInfoUuid === saleOption) {
            return {
              ...option,
              itemInfoValue: {
                ...option.itemInfoValue,
                [fieldName]: e.target.value,
              },
            };
          }
          return option;
        });

      setSubsidiaryDataZustand({
        ...subsidiaryDataZustand,
        selectedPdv: {
          ...subsidiaryDataZustand.selectedPdv,
          saleOptions: updatedSaleOptions,
        },
      });
    }
  };
  const handleProportionColumnnChange = (
    e: ChangeEvent<HTMLInputElement>,
    fieldName: string,
    componentParam?: string,
    columnId?: string
  ) => {
    const proportion = parseInt(e.target.value, 10);
    const newValue = proportion.toString() + "%";
    const updatedSaleOptions =
      subsidiaryDataZustand.selectedPdv.saleOptions.map((option) => {
        if (option.itemInfoUuid === saleOption) {
          return {
            ...option,
            itemInfoValue: {
              ...option.itemInfoValue,
              saleOptionComponents:
                option.itemInfoValue.saleOptionComponents.map((component) => {
                  if (component.componentId === componentParam && columnId) {
                    const updatedColumns =
                      component.componentProps.componentColumns?.map(
                        (column) => {
                          if (column.columnId === columnId) {
                            return {
                              ...column,
                              columnWidth: newValue, // update column width
                            };
                          }
                          return column;
                        }
                      );
                    return {
                      ...component,
                      componentProps: {
                        ...component.componentProps,
                        componentColumns: updatedColumns,
                      },
                    };
                  }
                  return component;
                }),
            },
          };
        }
        return option;
      });
    setSubsidiaryDataZustand({
      ...subsidiaryDataZustand,
      selectedPdv: {
        ...subsidiaryDataZustand.selectedPdv,
        saleOptions: updatedSaleOptions,
      },
    });
  };
  const getDimension = (value: string) => {
    const dimensionNumericValue = parseInt(value.replace("%", ""), 10);
    return dimensionNumericValue;
  };
  const columnInfoLabels = {
    check: "Selecionar",
    productName: "Nome do Produto",
    productQuantity: "Quantidade",
    productPrice: "Preço Unitário",
    productDiscount: "Desconto no Produto",
    productTotalPrice: "Preço Total",
    seller: "Vendedor",
    people: "Pessoa",
    productOrderedAt: "Pedido em:",
  };
  const rowsInfoLabels = {
    totalProductsPrice: "Total Produtos",
    totalDiscount: "Desconto Conta",
    totalProductsPriceWithDiscount: "Líquidos Produtos",
    taxs: "Impostos",
    totalProductsPriceWithDiscountAndTaxs: "Subtotal",
    serviceTax: "Taxa de Serviço",
    entranceTax: "Taxa de Ingresso",
    minimumConsumption: "Consumação Mínima",
    parkTax: "Taxa de Estacionamento",
    deliveryTax: "Taxa de Entrega",
    customerBalance: "Saldo",
    total: "Total",
  };
  return (
    <>
      <Styles.EditorContainer onClick={toggleMenu}>
        <img src={AlfredoIcon} alt="Alfredo Ops" />
        <link
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
          rel="stylesheet"
        />
      </Styles.EditorContainer>
      <Styles.MenuContainer open={saleOptionEditorOpen}>
        <Styles.Title>
          <Styles.MaterialIcon fontSize="var(--fs-3xl)">fact_check</Styles.MaterialIcon>
          Personalizar Opção de Venda Web
        </Styles.Title>
        <Styles.Divider />
        <Styles.SubTitle>
          <Styles.MaterialIcon fontSize="var(--fs-2xl)">home</Styles.MaterialIcon>
          Informações Gerais
        </Styles.SubTitle>
        <Styles.GeneralContent>
          <Styles.FlexRow padding={"var(--sp-20)"}>
            <Styles.Button color="#75f052e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                question_mark
              </Styles.MaterialIcon>
            </Styles.Button>
            <Styles.Button color="#fff340e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">sync</Styles.MaterialIcon>
            </Styles.Button>
            <Styles.TextInput color={"#7c7c7c"}>
              <input
                type="text"
                placeholder=""
                value={currentSaleOptionInfo?.itemInfoValue.saleOptionName}
                onChange={(e) => handleItemInfoValueChange(e, "saleOptionName")}
              />
              <label>Opção de Venda:</label>
            </Styles.TextInput>
          </Styles.FlexRow>
          <Styles.FlexRow padding={"var(--sp-20)"}>
            <Styles.Button color="#75f052e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                question_mark
              </Styles.MaterialIcon>
            </Styles.Button>
            <Styles.Button color="#fff340e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">sync</Styles.MaterialIcon>
            </Styles.Button>
            <Styles.TextInput color={"#7c7c7c"}>
              <input
                type="text"
                placeholder=""
                value={
                  Number(
                    currentSaleOptionInfo?.itemInfoValue.saleOptionType
                  ) === 1
                    ? "Atendimento em Mesa"
                    : Number(
                      currentSaleOptionInfo?.itemInfoValue.saleOptionType
                    ) === 2
                      ? "Retirada no Local"
                      : Number(
                        currentSaleOptionInfo?.itemInfoValue.saleOptionType
                      ) === 3
                        ? "Entrega"
                        : "Tipo de Venda"
                }
                onChange={(e) => handleItemInfoValueChange(e, "saleOptionType")}
              />
              <label>Tipo de Venda:</label>
            </Styles.TextInput>
          </Styles.FlexRow>
          <Styles.FlexRow padding={"var(--sp-20)"}>
            <Styles.Button color="#75f052e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                question_mark
              </Styles.MaterialIcon>
            </Styles.Button>
            <Styles.Button color="#fff340e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">sync</Styles.MaterialIcon>
            </Styles.Button>
            <Styles.TextInput color={"#7c7c7c"}>
              <input
                type="text"
                placeholder=""
                value={currentSaleOptionInfo?.itemInfoValue.saleOptionImg}
                onChange={(e) => handleItemInfoValueChange(e, "saleOptionImg")}
              />
              <label>Imagem:</label>
            </Styles.TextInput>
          </Styles.FlexRow>
          <Styles.FlexRow padding={"var(--sp-20)"}>
            <Styles.Button color="#75f052e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                question_mark
              </Styles.MaterialIcon>
            </Styles.Button>
            <Styles.Button color="#fff340e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">sync</Styles.MaterialIcon>
            </Styles.Button>
            <Styles.DropdownInput
              color={"#7c7c7c"}
            >
              <select
                value={currentSaleOptionInfo?.itemInfoValue.saleOptionPrinterAddress}
                onChange={(e) =>
                  handleItemInfoValueChange(e, "saleOptionPrinterAddress")
                }
              >
                {Array.isArray(subsidiaryDataZustand.selectedPdv.printers) && subsidiaryDataZustand.selectedPdv.printers.map((printer: any) => (
                  <option key={printer.printerUuid} value={printer.printerIp}>
                    {printer.printerName}
                  </option>
                ))}
              </select>
              <label>Impressora</label>
            </Styles.DropdownInput>
          </Styles.FlexRow>
          <Styles.FlexRow padding={"var(--sp-20)"}>
            <Styles.Button color="#75f052e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                question_mark
              </Styles.MaterialIcon>
            </Styles.Button>
            <Styles.Button color="#fff340e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">sync</Styles.MaterialIcon>
            </Styles.Button>
            <Styles.TextInput color={"#7c7c7c"}>
              <input
                type="text"
                placeholder=""
                value={String(
                  currentSaleOptionInfo?.itemInfoValue.saleOptionWidth
                )}
                onChange={(e) =>
                  handleItemInfoValueChange(e, "saleOptionWidth")
                }
              />
              <label>Largura:</label>
            </Styles.TextInput>
          </Styles.FlexRow>
          <Styles.FlexRow padding={"var(--sp-20)"}>
            <Styles.Button color="#75f052e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                question_mark
              </Styles.MaterialIcon>
            </Styles.Button>
            <Styles.Button color="#fff340e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">sync</Styles.MaterialIcon>
            </Styles.Button>
            <Styles.TextInput color={"#7c7c7c"}>
              <input
                type="text"
                placeholder=""
                value={String(
                  currentSaleOptionInfo?.itemInfoValue.saleOptionHeight
                )}
                onChange={(e) =>
                  handleItemInfoValueChange(e, "saleOptionHeight")
                }
              />
              <label>Altura:</label>
            </Styles.TextInput>
          </Styles.FlexRow>
          <Styles.FlexRow padding={"var(--sp-20)"}>
            <Styles.Button color="#75f052e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                question_mark
              </Styles.MaterialIcon>
            </Styles.Button>
            <Styles.Button color="#fff340e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">sync</Styles.MaterialIcon>
            </Styles.Button>
            <Styles.TextInput color={"#7c7c7c"}>
              <input
                type="text"
                placeholder=""
                value={
                  currentSaleOptionInfo?.itemInfoValue.saleOptionBackgroundColor
                }
                onChange={(e) =>
                  handleItemInfoValueChange(e, "saleOptionBackgroundColor")
                }
              />
              <label>Cor de Fundo:</label>
            </Styles.TextInput>
          </Styles.FlexRow>
          <Styles.FlexRow padding={"var(--sp-20)"}>
            <Styles.Button color="#75f052e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                question_mark
              </Styles.MaterialIcon>
            </Styles.Button>
            <Styles.Button color="#fff340e3">
              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">sync</Styles.MaterialIcon>
            </Styles.Button>
            <Styles.TextInput color={"#7c7c7c"}>
              <input
                type="text"
                placeholder=""
                value={
                  currentSaleOptionInfo?.itemInfoValue
                    .saleOptionBackgroundBrightness
                }
                onChange={(e) =>
                  handleItemInfoValueChange(e, "saleOptionBackgroundBrightness")
                }
              />
              <label>Brilho de Fundo:</label>
            </Styles.TextInput>
          </Styles.FlexRow>
        </Styles.GeneralContent>

        <Styles.SubTitle>
          <Styles.MaterialIcon fontSize="var(--fs-3xl)">apps</Styles.MaterialIcon>
          Componentes
        </Styles.SubTitle>
        <Styles.AccordionContainer>
          <Styles.AccordionInner>
            {currentSaleOptionInfo?.itemInfoValue.saleOptionComponents.map(
              (component: any) => (
                <Styles.AccordionItem key={component.componentId}>
                  <Styles.FlexRow
                    padding={"calc(var(--u) * 0)"}
                    onClick={() => handleSelectedFieldChange(component)}
                  >
                    <Styles.MaterialIcon
                      padding="var(--sp-10)"
                      fontSize="var(--fs-5xl)"
                      color="white"
                      backgroundColor="#00000090"
                    >
                      {component.componentSelected
                        ? "expand_less"
                        : "expand_more"}
                    </Styles.MaterialIcon>
                    <Styles.AccordionTitle>
                      {component.componentName}{" "}
                    </Styles.AccordionTitle>
                    <Styles.CheckboxContainer backgroundColor="#00000090">
                      <Styles.CheckboxLabel>
                        <Styles.CheckboxInput
                          type="checkbox"
                          onChange={() => {
                            handleItemInfoStatusChange(component.componentId);
                          }}
                          checked={component.componentStatus}
                        />
                        <Styles.CheckboxSlider
                          className={component.componentStatus ? "checked" : ""}
                          color={"#007bff"}
                        >
                          <Styles.CheckboxThumb
                            className={
                              component.componentStatus ? "checked" : ""
                            }
                          />
                        </Styles.CheckboxSlider>
                      </Styles.CheckboxLabel>
                    </Styles.CheckboxContainer>
                  </Styles.FlexRow>
                  {component.componentSelected && (
                    <Styles.AccordionContent>
                      <Styles.FlexRow padding={"var(--sp-20)"}>
                        <Styles.TextInput color={"#7c7c7c"}>
                          <input
                            type="text"
                            placeholder=""
                            value={
                              component.componentProps.componentBackgroundColor
                            }
                            onChange={(e) =>
                              handleItemInfoValueChange(
                                e,
                                "componentBackgroundColor",
                                component.componentId
                              )
                            }
                          />
                          <label>Cor de Fundo:</label>
                        </Styles.TextInput>
                        <Styles.Button color="#75f052e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            question_mark
                          </Styles.MaterialIcon>
                        </Styles.Button>
                        <Styles.Button color="#fff340e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            sync
                          </Styles.MaterialIcon>
                        </Styles.Button>
                      </Styles.FlexRow>
                      <Styles.FlexRow padding={"var(--sp-20)"}>
                        <Styles.TextInput color={"#7c7c7c"}>
                          <input
                            type="text"
                            placeholder=""
                            value={component.componentProps.componentPosition.x}
                            onChange={(e) =>
                              handleItemInfoValueChange(
                                e,
                                "componentPosition.x",
                                component.componentId
                              )
                            }
                          />
                          <label>Posição X:</label>
                        </Styles.TextInput>
                        <Styles.Button color="#75f052e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            question_mark
                          </Styles.MaterialIcon>
                        </Styles.Button>
                        <Styles.Button color="#fff340e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            sync
                          </Styles.MaterialIcon>
                        </Styles.Button>
                      </Styles.FlexRow>
                      <Styles.FlexRow padding={"var(--sp-20)"}>
                        <Styles.TextInput color={"#7c7c7c"}>
                          <input
                            type="text"
                            placeholder=""
                            value={component.componentProps.componentPosition.y}
                            onChange={(e) =>
                              handleItemInfoValueChange(
                                e,
                                "componentPosition.y",
                                component.componentId
                              )
                            }
                          />
                          <label>Posição Y:</label>
                        </Styles.TextInput>
                        <Styles.Button color="#75f052e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            question_mark
                          </Styles.MaterialIcon>
                        </Styles.Button>
                        <Styles.Button color="#fff340e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            sync
                          </Styles.MaterialIcon>
                        </Styles.Button>
                      </Styles.FlexRow>
                      <Styles.FlexRow padding={"var(--sp-20)"}>
                        <Styles.TextInput color={"#7c7c7c"}>
                          <input
                            type="text"
                            placeholder=""
                            value={component.componentProps.componentBrightness}
                            onChange={(e) =>
                              handleItemInfoValueChange(
                                e,
                                "componentBrightness",
                                component.componentId
                              )
                            }
                          />
                          <label>Brilho:</label>
                        </Styles.TextInput>
                        <Styles.Button color="#75f052e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            question_mark
                          </Styles.MaterialIcon>
                        </Styles.Button>
                        <Styles.Button color="#fff340e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            sync
                          </Styles.MaterialIcon>
                        </Styles.Button>
                      </Styles.FlexRow>
                      <Styles.FlexRow padding={"var(--sp-20)"}>
                        <Styles.TextInput color={"#7c7c7c"}>
                          <input
                            type="text"
                            placeholder=""
                            value={component.componentProps.componentWidth}
                            onChange={(e) =>
                              handleItemInfoValueChange(
                                e,
                                "componentWidth",
                                component.componentId
                              )
                            }
                          />
                          <label>Largura:</label>
                        </Styles.TextInput>
                        <Styles.Button color="#75f052e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            question_mark
                          </Styles.MaterialIcon>
                        </Styles.Button>
                        <Styles.Button color="#fff340e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            sync
                          </Styles.MaterialIcon>
                        </Styles.Button>
                      </Styles.FlexRow>
                      <Styles.FlexRow padding={"var(--sp-20)"}>
                        <Styles.TextInput color={"#7c7c7c"}>
                          <input
                            type="text"
                            placeholder=""
                            value={component.componentProps.componentHeight}
                            onChange={(e) =>
                              handleItemInfoValueChange(
                                e,
                                "componentHeight",
                                component.componentId
                              )
                            }
                          />
                          <label>Altura:</label>
                        </Styles.TextInput>
                        <Styles.Button color="#75f052e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            question_mark
                          </Styles.MaterialIcon>
                        </Styles.Button>
                        <Styles.Button color="#fff340e3">
                          <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                            sync
                          </Styles.MaterialIcon>
                        </Styles.Button>
                      </Styles.FlexRow>
                      {component.componentProps.componentLabel ? (
                        <Styles.FlexRow padding={"var(--sp-20)"}>
                          <Styles.TextInput color={"#7c7c7c"}>
                            <input
                              type="text"
                              placeholder=""
                              value={component.componentProps.componentLabel}
                              onChange={(e) =>
                                handleItemInfoValueChange(
                                  e,
                                  "componentLabel",
                                  component.componentId
                                )
                              }
                            />
                            <label>Legenda:</label>
                          </Styles.TextInput>
                          <Styles.Button color="#75f052e3">
                            <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                              question_mark
                            </Styles.MaterialIcon>
                          </Styles.Button>
                          <Styles.Button color="#fff340e3">
                            <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                              sync
                            </Styles.MaterialIcon>
                          </Styles.Button>
                        </Styles.FlexRow>
                      ) : null}
                      {component.componentProps.componentAction ? (
                        <Styles.FlexRow padding={"var(--sp-20)"}>
                          <Styles.DropdownInput color={"#7c7c7c"}>
                            <select
                              value={component.componentProps.componentAction}
                              onChange={(e) =>
                                handleItemInfoValueChange(
                                  e,
                                  "componentAction",
                                  component.componentId
                                )
                              }
                            >
                              <option value="AddProduct">
                                Adicionar Produto
                              </option>
                              <option value="AddObservation">
                                Incluir Observações
                              </option>
                              <option value="CancelOrder">
                                Cancelamento (pedido/produto/observação)
                              </option>
                              <option value="ChangeOrderStatus">
                                Bloquear Conta
                              </option>
                              <option value="PrintOrderInfo">
                                Imprimir via de conferência
                              </option>
                              <option value="PrintProduct">
                                Imprimir via de Produção
                              </option>
                              <option value="AddDiscount">
                                Adicionar Desconto
                              </option>
                              <option value="ReviewOrderTax">
                                Revisar Taxas da Conta
                              </option>
                              <option value="ReviewOrderInfo">
                                Revisar Informações da Conta
                              </option>
                              <option value="AddPayment">
                                Registrar Pagamento
                              </option>
                              <option value="ChangeEntity">
                                Transferir Conta
                              </option>
                              <option value="PartialWithdrawal">
                                Retiro Parcial
                              </option>
                              <option value="AccessOrders">
                                Acessar Contas do Período
                              </option>
                              <option value="PeriodContent">
                                Iniciar/Encerrar Período
                              </option>
                              <option value="AllOptions">
                                Acessar Outras Opções
                              </option>
                              <option value="BackToHome">
                                Voltar a Tela Inicial
                              </option>
                            </select>
                            <label>Ação disparada</label>
                          </Styles.DropdownInput>
                          <Styles.Button color="#75f052e3">
                            <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                              question_mark
                            </Styles.MaterialIcon>
                          </Styles.Button>
                          <Styles.Button color="#fff340e3">
                            <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                              sync
                            </Styles.MaterialIcon>
                          </Styles.Button>
                        </Styles.FlexRow>
                      ) : null}
                      {component.componentProps.componentShortcut !==
                        undefined ? (
                        <Styles.FlexRow padding={"var(--sp-20)"}>
                          <Styles.TextInput color={"#7c7c7c"}>
                            <input
                              type="text"
                              placeholder=""
                              value={component.componentProps.componentShortcut}
                              onKeyDown={(e: any) => {
                                e.preventDefault();
                                handleItemInfoValueChange(
                                  e,
                                  "componentShortcut",
                                  component.componentId
                                );
                              }}
                            />
                            <label>Digite a tecla de Atalho:</label>
                          </Styles.TextInput>
                          <Styles.Button color="#75f052e3">
                            <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                              question_mark
                            </Styles.MaterialIcon>
                          </Styles.Button>
                          <Styles.Button color="#fff340e3">
                            <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                              sync
                            </Styles.MaterialIcon>
                          </Styles.Button>
                        </Styles.FlexRow>
                      ) : null}
                      {component.componentProps.componentColumns ? (
                        <>
                          <Styles.FlexRow padding={"var(--sp-20)"}>
                            <Styles.SubTitle>
                              <Styles.MaterialIcon
                                fontSize="var(--fs-xl)"
                                padding="var(--sp-5)"
                              >
                                table_chart
                              </Styles.MaterialIcon>
                              Personalize as colunas desta tabela
                            </Styles.SubTitle>
                            <Styles.Button color="#75f052e3">
                              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                                question_mark
                              </Styles.MaterialIcon>
                            </Styles.Button>
                            <Styles.Button color="#fff340e3">
                              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                                sync
                              </Styles.MaterialIcon>
                            </Styles.Button>
                          </Styles.FlexRow>
                          {component.componentProps.componentColumns.map(
                            (column: any) => (
                              <div key={column.columnId}>
                                <Styles.FlexRow padding={"var(--sp-20)"}>
                                  <Styles.CheckboxContainer backgroundColor="">
                                    <Styles.CheckboxLabel>
                                      <Styles.CheckboxInput
                                        type="checkbox"
                                        onChange={() => {
                                          handleItemInfoStatusChange(
                                            component.componentId,
                                            column.columnId
                                          );
                                        }}
                                        checked={column.columnStatus}
                                      />
                                      <Styles.CheckboxSlider
                                        className={
                                          column.columnStatus ? "checked" : ""
                                        }
                                        color={"#007bff"}
                                      >
                                        <Styles.CheckboxThumb
                                          className={
                                            column.columnStatus ? "checked" : ""
                                          }
                                        />
                                      </Styles.CheckboxSlider>
                                    </Styles.CheckboxLabel>
                                  </Styles.CheckboxContainer>
                                  <Styles.DropdownInput color={"#7c7c7c"}>
                                    <select
                                      value={column.columnInfo}
                                      onChange={(e) =>
                                        handleItemInfoValueChange(
                                          e,
                                          "componentColumns.columnInfo",
                                          component.componentId,
                                          column.columnId
                                        )
                                      }
                                    >
                                      {Object.keys(columnInfoLabels).map(
                                        (key) => (
                                          <option key={key} value={key}>
                                            {
                                              columnInfoLabels[
                                              key as keyof typeof columnInfoLabels
                                              ]
                                            }
                                          </option>
                                        )
                                      )}
                                    </select>
                                    <label>Informação</label>
                                  </Styles.DropdownInput>
                                  <Styles.TextInput color={"#7c7c7c"}>
                                    <input
                                      type="text"
                                      placeholder=""
                                      value={column.columnLabel}
                                      onChange={(e) =>
                                        handleItemInfoValueChange(
                                          e,
                                          "componentColumns.columnLabel",
                                          component.componentId,
                                          column.columnId
                                        )
                                      }
                                    />
                                    <label>Título:</label>
                                  </Styles.TextInput>
                                  <Styles.FieldContainer>
                                    <Styles.ProportionSlider
                                      type="range"
                                      min="10"
                                      max={50}
                                      step={1}
                                      value={getDimension(column.columnWidth)}
                                      onChange={(e) =>
                                        handleProportionColumnnChange(
                                          e,
                                          "componentColumns.columnWidth",
                                          component.componentId,
                                          column.columnId
                                        )
                                      }
                                      color={
                                        subsidiaryDataZustand.selectedPdv
                                          .homeInfo.itemInfoValue.buttonsColor
                                      }
                                    />
                                  </Styles.FieldContainer>
                                </Styles.FlexRow>
                              </div>
                            )
                          )}
                        </>
                      ) : null}
                      {component.componentProps.componentRows ? (
                        <>
                          <Styles.FlexRow padding={"var(--sp-20)"}>
                            <Styles.SubTitle>
                              <Styles.MaterialIcon
                                fontSize="var(--fs-xl)"
                                padding="var(--sp-5)"
                              >
                                table_chart
                              </Styles.MaterialIcon>
                              Personalize as linhas desta tabela
                            </Styles.SubTitle>
                            <Styles.Button color="#75f052e3">
                              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                                question_mark
                              </Styles.MaterialIcon>
                            </Styles.Button>
                            <Styles.Button color="#fff340e3">
                              <Styles.MaterialIcon fontSize="calc(var(--u) * 25)">
                                sync
                              </Styles.MaterialIcon>
                            </Styles.Button>
                          </Styles.FlexRow>
                          {component.componentProps.componentRows.map(
                            (row: any) => (
                              <div key={row.rowId}>
                                <Styles.FlexRow padding={"var(--sp-20)"}>
                                  <Styles.CheckboxContainer backgroundColor="">
                                    <Styles.CheckboxLabel>
                                      <Styles.CheckboxInput
                                        type="checkbox"
                                        onChange={() => {
                                          handleItemInfoStatusChange(
                                            component.componentId,
                                            row.rowId
                                          );
                                        }}
                                        checked={row.rowStatus}
                                      />
                                      <Styles.CheckboxSlider
                                        className={
                                          row.rowStatus ? "checked" : ""
                                        }
                                        color={"#007bff"}
                                      >
                                        <Styles.CheckboxThumb
                                          className={
                                            row.rowStatus ? "checked" : ""
                                          }
                                        />
                                      </Styles.CheckboxSlider>
                                    </Styles.CheckboxLabel>
                                  </Styles.CheckboxContainer>
                                  <Styles.DropdownInput color={"#7c7c7c"}>
                                    <select
                                      value={row.rowInfo}
                                      onChange={(e) =>
                                        handleItemInfoValueChange(
                                          e,
                                          "componentRows.rowInfo",
                                          component.componentId,
                                          row.rowId
                                        )
                                      }
                                    >
                                      {Object.keys(rowsInfoLabels).map(
                                        (key) => (
                                          <option key={key} value={key}>
                                            {
                                              rowsInfoLabels[
                                              key as keyof typeof rowsInfoLabels
                                              ]
                                            }
                                          </option>
                                        )
                                      )}
                                    </select>
                                    <label>Informação</label>
                                  </Styles.DropdownInput>
                                  <Styles.TextInput color={"#7c7c7c"}>
                                    <input
                                      type="text"
                                      placeholder=""
                                      value={row.rowLabel}
                                      onChange={(e) =>
                                        handleItemInfoValueChange(
                                          e,
                                          "componentRows.rowLabel",
                                          component.componentId,
                                          row.rowId
                                        )
                                      }
                                    />
                                    <label>Título:</label>
                                  </Styles.TextInput>
                                </Styles.FlexRow>
                              </div>
                            )
                          )}
                        </>
                      ) : null}
                    </Styles.AccordionContent>
                  )}
                </Styles.AccordionItem>
              )
            )}
          </Styles.AccordionInner>
        </Styles.AccordionContainer>
      </Styles.MenuContainer>
    </>
  );
};

export default SaleOptionEditor;
